import { toast } from "sonner";
import baseApi from "store/api/baseApi";

const clientLeadsManagementApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getAllClientLeads: builder.query({
      query: () => ({
        url: "qwikITClientLeads/",
        method: "GET",
      }),
      providesTags: ["clientLeads"],
      transformResponse: response => response.reverse(),
    }),

    getClientLeadById: builder.query({
      query: id => ({
        url: `qwikITClientLeads/${id}/`,
        method: "GET",
      }),
      providesTags: ["clientLeads"],
      transformResponse: response => response,
    }),

    createClientLead: builder.mutation({
      query: data => ({
        url: "qwikITClientLeads/new/",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["clientLeads"],
      transformResponse: response => {
        toast.success("Client lead created successfully");
        return response;
      },
    }),

    updateClientLead: builder.mutation({
      query: ({ id, formData }) => ({
        url: `qwikITClientLeads/${id}/`,
        method: "PATCH",
        body: formData,
        headers: {

        },
      }),
      invalidatesTags: ["clientLeads"],
      transformResponse: response => {
        return response;
      },
    }),

    deleteClientLead: builder.mutation({
      query: id => ({
        url: `qwikITClientLeads/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["clientLeads"],
      transformResponse: response => {
        toast.success("Client lead deleted successfully");
        return response;
      },
    }),
  }),
});

export const {
  useGetAllClientLeadsQuery,
  useGetClientLeadByIdQuery,
  useCreateClientLeadMutation,
  useUpdateClientLeadMutation,
  useDeleteClientLeadMutation,
} = clientLeadsManagementApi;
